module.exports = __webpack_public_path__ + "static/media/pre-loader-gif.82a5c14e.gif";